import React from "react";
import style from "./LastOpen.module.css";
function Last() {
  return (
    <div className={style.Last}>
      <h5>Safety and sanitization assured cars with Revv in Delhi-NCR</h5>
      <p>
        When you are looking for car subscription, apart from the condition of
        the vehicle the other major concern is about the cleanliness and hygiene
        standards. We understand this at Revv, and that’s why our cars are not
        only free from any maintenance issues, but also thoroughly cleaned
        inside out to ensure you with safe and sanitized self-drive cars
        subscription in Delhi-NCR. With adherence to the guidelines of WHO, we
        ensure a hazard free car for you. The sanitized car subscription in
        Delhi-NCR will provide you with a great alternative to public transport
        where you and your family are exposed to the elements and hazards every
        day. When you book a sanitized car subscription in Delhi-NCR, you also
        break free from the liabilities that are associated with the car
        ownership such as the down payment, EMI, road tax and insurance. With
        the Revv monthly car subscription plans in Delhi-NCR your cost of car
        ownership in Delhi-NCR is easily managed, and it saves you money
        month-after-month.
      </p>
      <h5>Revv facilitates a flexible car subscription experience</h5>
      <p>
        The Revv car subscription plans in Delhi-NCR are value oriented, and the
        best part is that you can change the subscription plan after a while.
        You can explore any Revv car subscription model in Delhi-NCR which maybe
        more popular amongst the car subscribers in Delhi-NCR. If you are
        searching for an affordable car subscription near you in Delhi-NCR, Revv
        is definitely a great option for you. You can even share your Revv car
        subscription plan with a friend for shouldering the cost, once you have
        informed Revv and provided the needful credentials. Revv cars
        subscription come with huge varieties of make and model. Once you are on
        the Revv page and subscribed for your dream car, it will be delivered to
        your doorstep. Car subscription in Delhi-NCRalso comes with additional
        features such as free service and maintenance, and the possibility of
        extending or shortening your subscription period. You can even buy out
        the car if you wish so at the end of your Revv car subscription in
        Delhi-NCR period.
      </p>
    </div>
  );
}

export default Last;
